export const GET_SKILL_TAGS = 'GET_SKILL_TAGS';
export const GET_SKILL_TAG_BY_ID = 'GET_SKILL_TAG_BY_ID';
export const UPDATE_SKILL_TAG = 'UPDATE_SKILL_TAG';
export const DELETE_SKILL_TAG = 'DELETE_SKILL_TAG';
export const CREATE_SKILL_TAG = 'CREATE_SKILL_TAG';
